import React, { useState } from "react";
import { Typography, Stack, Snackbar, Box } from "@mui/material";

const ContactInfo = (props) => {
  const [snackMessage, setSnackMessage] = useState("");

  const copyPhone = (type = null) => {
    if (!type) {
      navigator.clipboard.writeText("323-653-5900");
    } else {
      navigator.clipboard.writeText("626-788-3663");
    }

    setSnackMessage("Phone number copied to clipboard");
  };

  return (
    <Box mt={1} textAlign="center">
      <Typography variant="caption" color="text.secondary">
        <Stack>
          <a
            href="mailto:orders@friendly-foods.com"
            style={{ color: "inherit" }}
          >
            orders@friendly-foods.com
          </a>
          <span
            onClick={() => copyPhone()}
            style={{ cursor: "pointer", textDecoration: "underline" }}
          >
            Office: (323) 653-5900
          </span>
          <span
            onClick={() => copyPhone(2)}
            style={{ cursor: "pointer", textDecoration: "underline" }}
          >
            Office Text: (626) 788-3663
          </span>
          <br />
          <span>
            <b>Mon-Fri</b> 7am-3pm PST
          </span>
          <span>
            <b>Sun</b> 8am-3pm PST
          </span>
        </Stack>
      </Typography>
      <Snackbar
        open={!!snackMessage}
        autoHideDuration={2500}
        onClose={() => setSnackMessage("")}
        message={snackMessage}
      />
    </Box>
  );
};

export default ContactInfo;
